import React, { useState } from 'react';

import { DurationInput } from '../../components/form/duration-input';
import { Duration } from 'luxon';

export const CycleBillingDurationConfig = ({ initialValue }: { initialValue: string }) => {
  const [value, setValue] = useState<Duration>(Duration.fromISO(initialValue));
  return (
    <div>
      <input type="hidden" name="CONF_CYCLE_BILLING_LENGTH" value={value.toISO()} />
      <DurationInput value={value} onChange={setValue} allowedUnits={['days', 'weeks', 'months']} />
    </div>
  );
};
